import { svgIconPaths } from '@/assets/svg/icons';
import CustomButton from '@/components/atoms/CustomButton';
import SidebarItemViewTemplate from '@/components/templates/SidebarItemViewTemplate';
import appRoutes from '@/constants/routes/app';
import colors from '@/theme/colors';
import { HStack } from '@chakra-ui/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import useCreateProvider from '@/hooks/providers/useCreateProvider';
import ProviderForm from '@/modules/provider/ProviderForm';

const ProviderCreate = () => {
  const navigate = useNavigate();
  const { isPending, mutate } = useCreateProvider();

  return (
    <SidebarItemViewTemplate title="Create Provider">
      <HStack justify={'flex-start'} width={'100%'} marginTop={'20px'}>
        <CustomButton
          isTransparent
          iconBeforeLabelSvgPath={svgIconPaths.leftArrow}
          labelColor={colors.background.blueGray}
          labelHoverColor="extra.black"
          label="Back to Providers"
          hoverBackgroundColor="transparent"
          borderHoverColor="transparent"
          onClick={() => navigate({ to: appRoutes.providers })}
          labelStyle={{ marginBottom: '5px', fontSize: '16px' }}
        />
      </HStack>
      <ProviderForm isPending={isPending} onSubmit={(form, photo) => mutate({ form, photo })} />
    </SidebarItemViewTemplate>
  );
};

export const Route = createFileRoute('/_authenticated/_admin/providers/create/')({
  component: ProviderCreate,
});
